import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportOsXFinancial } from './OsXFinancial.service';

export function useOsXFinancialReport() {
  return useMutation(getQuestReportOsXFinancial, {
    onSuccess() {
      notification.success({
        message: 'O relatório OS x Financeiro foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
